import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { images, strings } from 'config';

const BackLink = () => (
  <Content lang={strings.getLanguage()} className="back-link" to="/" icon={images.icons.back} iconBlue={images.icons.backTeal}>
  {strings.detail.goBack}
    <img src={images.icons.backTeal} alt=""/>
  </Content>
);

export default BackLink;

const Content = styled(NavLink)`
  
  background: url('${props => props.icon}') no-repeat left center;
  color: #979797;
  font-size: ${props => props.lang === 'en' ? '12px' : '14px'};  
  padding: 6px 0 6px 30px;

  img{
    display: none;
  }

  &:hover {
    color: ${props => props.theme.teals.tilicho};
    background: url('${props => props.iconBlue}') no-repeat left center;
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/backLink/backLink.js